import { useRef, useState } from "react";
import film from "@/assets/demo-film.mp4.asset.json";
import poster from "@/assets/demo-film-poster.jpg.asset.json";
import { Btn, CONTACT, Eyebrow } from "./core";

const chapters = [
  { t: 0, n: "00", label: "The story", sub: "Every service tells one" },
  { t: 20, n: "01", label: "The platform", sub: "Menu, POS, kitchen, one place" },
  { t: 70, n: "02", label: "Korner Ask", sub: "Know the guest before the greeting" },
  { t: 130, n: "03", label: "Chef Brain", sub: "The same data, turned into decisions" },
];

export function DemoFilm() {
  const ref = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  const play = (t?: number) => {
    const v = ref.current;
    if (!v) return;
    if (typeof t === "number") v.currentTime = t;
    v.play();
    setPlaying(true);
  };

  return (
    <section className="tk-sec tk-sec--luxe tk-film" id="demo-film">
      <div className="tk-wrap">
        <div className="tk-head tk-head--center">
          <Eyebrow>Three minutes, the whole idea</Eyebrow>
          <h2 className="tk-h2">See one dinner service <em>run on thatKorner.</em></h2>
          <p className="tk-lede">From the menu your chef builds once, to the sommelier who already knows the guest, to the numbers your F&amp;B director reads the next morning. Press play and watch the whole service connect.</p>
        </div>

        <div className="tk-film__frame">
          <video
            ref={ref}
            src={film.url}
            poster={poster.url}
            preload="none"
            playsInline
            controls={playing}
            onPause={() => {}}
            aria-label="thatKorner platform demo film"
          />
          {!playing && (
            <button type="button" className="tk-film__play" onClick={() => play()} aria-label="Play the demo film">
              <span className="tk-film__btn"><svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor" /></svg></span>
              <span className="tk-film__cap">Watch the platform demo · 3 min</span>
            </button>
          )}
        </div>

        <ol className="tk-film__chapters">
          {chapters.map((c) => (
            <li key={c.n}>
              <button type="button" onClick={() => play(c.t)}>
                <em>{c.n}</em>
                <b>{c.label}</b>
                <span>{c.sub}</span>
              </button>
            </li>
          ))}
        </ol>

        <div className="tk-row tk-film__cta">
          <Btn to={CONTACT} kind="gold">Book a live demo</Btn>
          <span className="tk-fine">Seen enough? We will walk you through it with your own menu.</span>
        </div>
      </div>
    </section>
  );
}
